"use strict";
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var en_US_1 = __importDefault(require("./lang/en_US"));
var zh_CN_1 = __importDefault(require("./lang/zh_CN"));
/**
 * All locales supported. en_US, zh_CN is build-in
 * @type {{en: function(*, *), zh_CN: function(*, *)}}
 */
var Locales = {
    en_US: en_US_1.default,
    zh_CN: zh_CN_1.default,
};
/**
 * register a locale
 * @param locale
 * @param func
 */
exports.register = function (locale, func) {
    Locales[locale] = func;
};
/**
 * get a locale, default is en_US
 * @param locale
 * @returns {*}
 */
exports.getLocale = function (locale) {
    return Locales[locale] || en_US_1.default;
};
//# sourceMappingURL=locales.js.map